import PropTypes from "prop-types";
import { Component } from "react";
import { OFFER_TYPES } from "app/constants";
import { FormattedMessage } from "react-intl";
import { offerTypePropTypes } from "app/utils/propTypes";
import DurationLabel from "app/pages/.shared/DurationLabel";
import Radio from "app/pages/.shared/form/Radio.jsx";
import AmountContainer from "app/pages/.shared/AmountContainer.jsx";

class Duration extends Component {
	constructor() {
		super();
		this.onChange = this.onChange.bind(this);
	}

	onChange() {
		this.props.onChange(this.props.duration);
	}

	render() {
		const {
			field,
			duration,
			minPrice,
			publicPrice,
			amountSuffix,
			productInfo,
			offerType,
			...props
		} = this.props;

		return (
			<Radio
				field={field}
				id={`duration-${duration}`}
				value={Number(duration)}
				toggle={this.onChange}
				checked={Number(field.value) === duration}
				data-testid={props["data-testid"]}
			>
				<div className="duration__content ignore-react-onclickoutside">
					<div className="duration__label">
						<DurationLabel duration={duration} />
					</div>

					{minPrice && (
						<div className="duration__price">
							<AmountContainer
								amount={minPrice}
								prefix={<FormattedMessage id="offer.per.person.from.label" />}
								suffix={amountSuffix}
							/>
						</div>
					)}

					{publicPrice && (
						<div className="duration__price duration__public-price">
							<AmountContainer amount={publicPrice} suffix={amountSuffix} />
						</div>
					)}

					{productInfo.ul === true &&
						offerType === OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION && (
							<div className="duration__info">
								<FormattedMessage id="search.engine.departure.city.info.business.flight" />
							</div>
						)}
				</div>
			</Radio>
		);
	}
}

Duration.defaultProps = {
	field: {},
	productInfo: {},
};

Duration.propTypes = {
	offerType: offerTypePropTypes,
	productInfo: PropTypes.object,
	amountSuffix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	duration: PropTypes.number,
	minPrice: PropTypes.number,
	publicPrice: PropTypes.number,
	field: PropTypes.object,
	onChange: PropTypes.func,
};

export default Duration;
